import { apiClient } from './client';

/**
 * 대표 업무보고 (2026-09-01 · 파이프라인 하네스 판 I).
 *
 * ★ 이름이 `exec` 였다가 **`briefing`** 으로 바뀌었다 — `exec` 는 **실행(execute)** 으로
 *   읽히고, `report` 는 업무 보고 문서(`work_reports`)와 헷갈린다.
 *
 * ★★★ **모르는 것은 «부분합 + 미산정 인원»** 으로 온다 — 0 으로 채우면 「그 사람 연차가 0」
 *    이라는 거짓이고, 통째로 비우면 아무것도 못 보여 준다. 화면은 `unknownQuota` 가 0 이
 *    아니면 **그 사실을 말해야 한다.**
 * ★★ `notAvailable` 은 **지금 데이터로 셀 수 없는 것**의 목록이다 — 화면이 빈 그래프를
 *    그리는 대신 「아직 없습니다」라고 말한다.
 */
export interface BriefingDto {
  period: { from: string; to: string };
  reports: {
    byKind: { DAILY: number; WEEKLY: number; MONTHLY: number };
    submitters: number;
    headcount: number | null;
    byTeam: Array<{ teamId: string | null; count: number; submitters: number }>;
  };
  approval: {
    inProgress: number;
    waitingOnMe: number;
    completed: number;
    avgHoursToComplete: number | null;
  };
  attendance: {
    workedDays: number;
    openDays: number;
    approvedLeaveDays: number;
    approvedOvertimeMinutes: number;
  };
  leave: {
    grantedDays: number;
    usedDays: number;
    pendingDays: number;
    remainingDays: number;
    /** 이 숫자가 몇 명분인가. */
    countedOf: number;
    /** 부여를 못 세어 **뺀** 사람 수. 0 이 아니면 화면이 그 사실을 말한다. */
    unknownQuota: number;
  };
  /** 업무 — 완료율은 할 일이 없으면 `null`(0% 가 아니다). */
  work: { projects: number; tasks: number; done: number; overdue: number; donePercent: number | null };
  /**
   * 평가 — **회차가 0 이면 「아직 안 시작」**이고 아래가 전부 `null` 이다.
   * ★ 0% 로 그리면 「아무도 안 냈다」로 읽힌다 — 시작조차 안 한 것과 다르다.
   */
  evaluation: {
    rounds: number;
    inProgressRound: string | null;
    targets: number | null;
    submitted: number | null;
    percent: number | null;
  };
  /** 교육 — 과정이 0 이면 아래가 `null`(「아직 없다」). */
  education: { courses: number; statutoryCourses: number | null; completions: number | null; notCompleted: number | null };
  reservation: { confirmed: number; pending: number; bookedMinutes: number };
  people: { headcount: number; joined: number; leaving: number; assignments: number };
  notAvailable: string[];
}

export async function getBriefing(params?: { from?: string; to?: string }): Promise<BriefingDto> {
  const { data } = await apiClient.get<BriefingDto>('/briefing/summary', { params });
  return data;
}
